import { createFileRoute, lazyRouteComponent, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/too-many-requests/")({
  staticData: { title: "Too Many Requests" },
  beforeLoad: ({ context }) => {
    if (context.userInfo.state === "LoggedIn") {
      throw redirect({ to: "/" })
    }
  },
  component: lazyRouteComponent(
    () => import("#pages/login/too-many-requests.tsx"),
    "TooManyRequests",
  ),
})
